import { CapacityType } from 'features/contracts/enums/capacityType';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  type: CapacityType;
}

const CapacityTypeLabel = ({ type }: Props) => {
  const { t } = useTranslation(["contracts\\enums\\capacityElectricityType"]);

  switch (type) {
    case CapacityType.Draft:
      return (
        <span className="badge badge-pill badge-info small font-weight-normal">
          {t(type)}
        </span>
      );
    case CapacityType.Valid:
      return (
        <span className="badge badge-pill badge-success small font-weight-normal">
          {t(type)}
        </span>
      );
    case CapacityType.Rejected:
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal">
          {t(type)}
        </span>
      );
    default:
      return null;
  }
}

export default CapacityTypeLabel;
